/*@ngInject*/
const ErrorInResponseInterceptor = function ($rootScope, $q, $injector, coreConstant, loadingBarHandler, registerableResourceConstants) {

    var _umsLog;

    function getUmsLog() {
        if (!_umsLog) {
            _umsLog = $injector.get('umsLog');
        }
        return _umsLog;
    }

    return {
        responseError: function (response) {
            var invalidSessionError = response.status === 454,
                umsLog,
                error;

            if (invalidSessionError) {
                $rootScope.$broadcast(coreConstant.event.INVALID_SESSION);
            } else if (response.data && response.headers().returnstatusdesc === 'expired password') {
                $rootScope.$broadcast(coreConstant.event.EXPIRED_PASSWORD);
            } else if (response.data && response.data.errorMessage === registerableResourceConstants.INVALID_REGISTRATION_IDENTIFIER_ERROR) {
                return $q.resolve(response);
            } else if (_.includes(response.config.url, '/localization.json')) { // Log, but don't display  error for missing language pack.  Silent fallback to English
                umsLog = getUmsLog();
                error = response.config.method + ' ' + response.config.url + ' ' + response.status + ' (' + response.statusText + ')';
                umsLog.error.apply(umsLog, [error, response.config.url]);
            } else if (!_.includes(response.config.url, '/rest/Log')) { // Make sure we don't log errors from errors while logging errors :)
                umsLog = getUmsLog();
                error = response.config.method + ' ' + response.config.url + ' ' + response.status + ' (' + response.statusText + ')';

                umsLog.error.apply(umsLog, [error, response.config.url]).then(function (logInfo) {
                    $rootScope.$broadcast(coreConstant.event.HANDLE_ERROR, response.data, logInfo);
                });
            }

            loadingBarHandler.hideLoadingBar();
            loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);

            return $q.reject(response);
        }
    };
};

angular.module('umCore')
    .factory('errorInResponseInterceptor', ErrorInResponseInterceptor);

angular.module('umCore')
    .config(function ($httpProvider) {
        $httpProvider.interceptors.push('errorInResponseInterceptor');
    });
